// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugOutlinedSvg from "@fishx/icons-svg/es/asn/BugOutlined";
import FishxIcon from '../components/FishxIcon';

var BugOutlined = function BugOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugOutlinedSvg
  }));
};

BugOutlined.displayName = 'BugOutlined';
export default React.forwardRef(BugOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BugOutlined.js
// module id = 2124
// module chunks = 0